import { unref as _unref, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-94ce3bae"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "alarm-monitor-real"
};
const _hoisted_2 = {
  class: "top-container"
};
const _hoisted_3 = {
  class: "search-left"
};
const _hoisted_4 = {
  class: "top-container"
};
const _hoisted_5 = {
  class: "search-left"
};
import moment from "moment";
import { reactive, watch, ref, onMounted, nextTick } from "vue";
import { weChatrequest } from '@/utils/request';
import { getrHistoryWarning } from "@/api/deviceManage";
import { useStore } from "vuex";
const __default__ = {
  name: "alarm-monitor-real"
};
export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props) {
    const store = useStore();
    // 获取用户类型
    const userType = store.state.common.userInfo.userType;
    let startTime = moment().subtract(6, "days").format("YYYY-MM-DD") + " 00:00:00";
    let endTime = moment().format("YYYY-MM-DD") + " 23:59:59";
    const state = reactive({
      split: 0.13,
      defaultProps: {
        label: "name",
        children: "children"
      },
      treeData: [],
      defaultCheckNode: [],
      defaultExendNode: [],
      currentNodeKey: '',
      tableData: {
        rows: [],
        total: 0
      }
    });
    let queryParams = reactive({
      pageNum: 1,
      // 当前页数
      pageSize: 10,
      //  每页数目
      endTime: endTime,
      startTime: startTime,
      dateRange: [startTime, endTime],
      actNum: "",
      valveName: "",
      areaId: ''
    });
    const searchFormData = ref([{
      prop: "valveName",
      label: "阀井名称",
      placeholder: "请输入阀井名称",
      type: "text",
      span: 4
    }, {
      prop: "actNum",
      label: "执行器编号",
      placeholder: "请输入执行器编号",
      type: "text",
      span: 4
    }, {
      prop: "dateRange",
      type: "datetimerange",
      label: "告警时间",
      span: 2,
      pickerOptions: {
        disabledDate: time => {
          // return time.getTime() > Date.now() || time.getTime() < Date.now()
          return time.getTime() > Date.now();
        }
      },
      change: val => {
        if (!val) {
          queryParams.startTime = "";
          queryParams.endTime = "";
        } else {
          queryParams.startTime = val[0];
          queryParams.endTime = val[1];
        }
      }
    }]);
    let loading = ref(false);
    const getList = () => {
      loading.value = true;
      delete queryParams.dateRange;
      getrHistoryWarning(queryParams).then(res => {
        if (res.code == 0) {
          state.tableData.rows = res.data.records;
          state.tableData.total = res.data.total;
        }
      }).finally(() => {
        loading.value = false;
      });
    };
    const resetQuery = () => {
      getList();
    };
    const formHandle = [{
      label: "搜索",
      type: "primary",
      icon: "el-icon-search",
      class: "btn-liquid",
      handle: () => getList()
    }, {
      label: "重置",
      icon: "el-icon-refresh",
      class: "commonDarkBtn",
      handle: () => resetQuery()
    }];
    const tableHeader = [{
      prop: "valveName",
      label: "阀井名称",
      fixed: false,
      type: "text"
    }, {
      prop: "actNum",
      label: "设备编号",
      fixed: false,
      type: "text"
    }, {
      prop: "location",
      label: "设备位置",
      fixed: false,
      type: "text"
    }, {
      prop: "alarmTime",
      label: "告警时间",
      fixed: false,
      type: "text"
    }, {
      prop: "alarmDesc",
      label: "告警描述",
      fixed: false,
      type: "text"
    }, {
      prop: "duringDesc",
      label: "告警持续时间",
      fixed: false,
      type: "text"
    }, {
      prop: "alarmEndTime",
      label: "告警消缺时间",
      fixed: false,
      type: "text"
    }];
    const handleNodeClick = params => {
      nextTick(() => {
        state.defaultCheckNode = [params];
      });
      queryParams.areaId = params.id;
      state.currentNodeKey = params.id;
      getList();
    };
    onMounted(async () => {
      state.loading = true;
      weChatrequest({
        url: '/api/v1/sysArea/findTree',
        method: "get"
      }).then(res => {
        state.treeData = [res.data];
        if (state.treeData[0]?.children) {
          state.defaultExendNode = state.treeData[0].children[0].id;
        }
        state.loading = false;
      }).catch(() => {
        state.loading = false;
      });
    });
    return (_ctx, _cache) => {
      const _component_treeSelect = _resolveComponent("treeSelect");
      const _component_commonForm = _resolveComponent("commonForm");
      const _component_commonTable = _resolveComponent("commonTable");
      const _component_splitPane = _resolveComponent("splitPane");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_unref(userType) == 3 ? (_openBlock(), _createBlock(_component_splitPane, {
        key: 0,
        value: state.split,
        "onUpdate:value": _cache[1] || (_cache[1] = $event => state.split = $event)
      }, {
        leftContent: _withCtx(() => [_withDirectives(_createVNode(_component_treeSelect, {
          ref: "tree",
          title: "地区树",
          onHandleNodeClick: handleNodeClick,
          defaultExpand: false,
          data: state.treeData,
          "default-props": state.defaultProps,
          defaultExendNode: state.defaultExendNode,
          defaultCheckNode: state.defaultCheckNode,
          nodeKey: "id",
          currentNodeKey: _ctx.currentNodeKey
        }, null, 8, ["data", "default-props", "defaultExendNode", "defaultCheckNode", "currentNodeKey"]), [[_directive_loading, state.loading]])]),
        rightContent: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_commonForm, {
          form: _unref(queryParams),
          formData: searchFormData.value,
          showLabel: true,
          formHandle: formHandle
        }, null, 8, ["form", "formData"])])]), _withDirectives(_createVNode(_component_commonTable, {
          size: "medium",
          ref: "tableContainer",
          style: {
            "clear": "both"
          },
          hasStripe: false,
          hasSelect: false,
          tableData: state.tableData,
          tableHeaderName: "monitorAlarmRealTime",
          multipleSelection: state.multipleSelection,
          "onUpdate:multipleSelection": _cache[0] || (_cache[0] = $event => state.multipleSelection = $event),
          tableHeader: tableHeader,
          queryParams: _unref(queryParams),
          onGetList: getList
        }, null, 8, ["tableData", "multipleSelection", "queryParams"]), [[_directive_loading, _unref(loading)]])]),
        _: 1
      }, 8, ["value"])) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_commonForm, {
        form: _unref(queryParams),
        formData: searchFormData.value,
        showLabel: true,
        formHandle: formHandle
      }, null, 8, ["form", "formData"])])]), _withDirectives(_createVNode(_component_commonTable, {
        size: "medium",
        ref: "tableContainer",
        style: {
          "clear": "both"
        },
        hasStripe: false,
        hasSelect: false,
        tableData: state.tableData,
        tableHeaderName: "monitorAlarmRealTime",
        multipleSelection: state.multipleSelection,
        "onUpdate:multipleSelection": _cache[2] || (_cache[2] = $event => state.multipleSelection = $event),
        tableHeader: tableHeader,
        queryParams: _unref(queryParams),
        onGetList: getList
      }, null, 8, ["tableData", "multipleSelection", "queryParams"]), [[_directive_loading, _unref(loading)]])], 64))]);
    };
  }
});